import React from 'react'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
import { List } from 'antd-mobile'
import UAParser from 'ua-parser-js'

export default class OpenNativeList extends React.Component {
  constructor(props) {
    super(props)
    const OSName = new UAParser().getOS().name
    this.state = { OSName }
  }

  handleSelectedItem = (item) => {
    this.setState({ selectedItem: item.appCode })
    this.props.onChange(item.redirectUrl)
  }

  render() {
    const { data = [], title } = this.props
    const { OSName } = this.state
    console.log(OSName)
    if (OSName !== 'Android' && OSName !== 'iOS') {
      return (
        <List className={classes.componentsOpenNativeList} renderHeader={title}>
          <List.Item
            thumb={<span className='iconfont font-md iconNorecords' />}
          >
            <div className={classes.notSupportInfo}>
              The current device does not support it, only Android and iOS are
              supported.
            </div>
          </List.Item>
        </List>
      )
    }
    return (
      <List className={classes.componentsOpenNativeList} renderHeader={title}>
        {data.map((item, index) => {
          return (
            <List.Item
              key={index}
              thumb={item.logoUrl}
              extra={
                <span
                  className={`iconfont font-md ${
                    item.appCode === this.state.selectedItem
                      ? 'iconRadio-Selected green'
                      : 'iconRadio'
                  }`}
                />
              }
              onClick={() => this.handleSelectedItem(item)}
            >
              {item.title}{' '}
              {item.isRecommend === 'true' && <img src={item.recommendIcon} />}
              {item.txtFont && (
                <span
                  className={`pull-right ${classes.opText}`}
                  style={{ color: item.txtFont.txtColor }}
                >
                  {item.txtFont.txt}
                </span>
              )}
            </List.Item>
          )
        })}
      </List>
    )
  }
}

// 呼起native功能的列表组件，可通过全局方法getOpenNativeLink获取对应场景的link数据
// @data 配置的deeplink或者app link列表数据
// @title 列表的title文本
// @onChange 切换列表选中的回调

// <OpenNativeList
//   data={siteConfig.openNativeLinks}
//   title='Payment Method'
//   onChange={this.handleOpenNativeLink}
// />
